import { render, staticRenderFns } from "./children-ja.vue?vue&type=template&id=5e623858&lang=pug&"
import script from "./children-ja.vue?vue&type=script&lang=js&"
export * from "./children-ja.vue?vue&type=script&lang=js&"
import style0 from "./children-ja.vue?vue&type=style&index=0&id=5e623858&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports